
import { Component, Vue } from "vue-property-decorator";

@Component({
  components: {
    Order: () => import("@/app/modules/orders/components/OrderComponent.vue")
  }
})
export default class OrdersPage extends Vue {
  get ordersData() {
    return this.$store.getters["orders/data"];
  }

  created() {
    this.$store.dispatch("orders/fetchAll").then(({ data }) => {
      this.$store.commit("orders/setData", data.data);
    });
  }
}
